import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import SmartFeedPagination from "%/dynamic-component-editor/options/smart-feed-pagination";

export default class SmartFeedSeeMoreText extends BaseOption {
  static label = "See More Text";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
  };
  static defaultValue = "See More";

  static canShow(paginationType) {
    let paginationTypeId = paginationType;
    if (typeof paginationTypeId === "object") {
      paginationTypeId = paginationTypeId.id;
    }
    return paginationTypeId === SmartFeedPagination.optionValues.clickToPaginate.id;
  }
}
